import Head from 'next/head';
import { FC } from 'react';

export type StructuredDataProps = {
  name: string;
  description: string;
  thumbnailUrl: string[];
  uploadDate: string;

  embedUrl?: string;
  duration?: string;
} & Partial<typeof defaultStructuredDataProps>;

const defaultStructuredDataProps = {
  '@context': 'http://schema.org',
  '@type': 'VideoObject'
};

const makeShame = (props: StructuredDataProps) =>
  JSON.stringify({
    ...defaultStructuredDataProps,
    ...props
  });

const StructuredData: FC<StructuredDataProps> = props => (
  <Head key="structured_data">
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: makeShame(props) }}
    />
  </Head>
);

export default StructuredData;
